import styled from 'styled-components';

export const Box = styled.div`
  width: 100%;
`;

export const UploadImageButton = styled.button`
  line-height: 21px;
  font-size: 14px;
  margin-bottom: 5.5px;
  display: flex;
  justify-content: center;
  width: 100%;
  align-items: center;
  color: ${(props) => props.theme.colors['primary-60']};
  svg {
    margin-right: 6px;
    font-size: 16px;
    position: relative;
    top: -2px;
  }
`;

export const ImageUrlInput = styled.input`
  border: 1px solid;
  width: 100%;
  margin-bottom: 10px;
  padding: 5px 12px;
  color: ${(props) => props.theme.colors['primary-60']};
  border-color: ${(props) => props.theme.colors['neutral-40']};
  border-radius: 4px;
`;

export const Image = styled.img`
  width: 100%;
`;

export const Footer = styled.div`
  display: flex;
  margin-top: 4px;
  gap: 16px;
`;

export const InvalidWarning = styled.p`
  color: ${(props) => props.theme.colors['light-red']};
  font-size: 14px;
  display: flex;
  align-items: center;
  svg {
    margin-right: 6px;
    font-size: 16px;
    position: relative;
    top: -2px;
  }
`;

export const OrText = styled.p`
  text-align: center;
  color: #979797;
  margin-bottom: 10px;
  font-size: 14px;
`;
